var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalTestPlanned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1953 1.375C11.1953 0.891795 11.5535 0.5 11.9953 0.5H18.3953C18.8371 0.5 19.1953 0.891795 19.1953 1.375V4.875C19.1953 5.3582 18.8371 5.75 18.3953 5.75H11.9953C11.5535 5.75 11.1953 5.3582 11.1953 4.875V1.375Z",
    fill: "#0EA5E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.25H9.6V6.3334C9.6 6.97775 10.1014 7.5 10.72 7.5H19.68C20.2986 7.5 20.8 6.97775 20.8 6.3334V2.25H22.4C24.6091 2.25 26.4 4.2088 26.4 6.625V24.125C26.4 26.5412 24.6091 28.5 22.4 28.5H8C5.7909 28.5 4 26.5412 4 24.125V6.625C4 4.2088 5.7909 2.25 8 2.25ZM15.2 12.75C14.7582 12.75 14.4 13.1418 14.4 13.625C14.4 14.1082 14.7582 14.5 15.2 14.5H21.6C22.0418 14.5 22.4 14.1082 22.4 13.625C22.4 13.1418 22.0418 12.75 21.6 12.75H15.2ZM14.4 20.625C14.4 20.1418 14.7582 19.75 15.2 19.75H18.4C18.8418 19.75 19.2 20.1418 19.2 20.625C19.2 21.1082 18.8418 21.5 18.4 21.5H15.2C14.7582 21.5 14.4 21.1082 14.4 20.625ZM8 13.625C8 12.1752 9.07447 11 10.4 11C11.7255 11 12.8 12.1752 12.8 13.625C12.8 15.0748 11.7255 16.25 10.4 16.25C9.07447 16.25 8 15.0748 8 13.625ZM8 20.625C8 19.1752 9.07447 18 10.4 18C11.7255 18 12.8 19.1752 12.8 20.625C12.8 22.0748 11.7255 23.25 10.4 23.25C9.07447 23.25 8 22.0748 8 20.625Z",
    fill: "#0EA5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTestPlanned);
export default __webpack_public_path__ + "static/media/TotalTestPlanned.bed4a9a65893beb803fe5e170cc62b7d.svg";
export { ForwardRef as ReactComponent };